import React from "react";
import ChatBot from "react-simple-chatbot";

function CustomChatbot(props) {
   const config = {
     width: "300px",
     height: "400px"//,
     //floating: true
   };
  
   function handleEnd({ steps, values }) {
     //console.log(steps);
     //console.log(values);
    //alert(`Chat handleEnd callback! Number: ${values[0]}`);
    

   };
   const steps = [
   {
     id: "Greet",
     message: "Hello, nice to meet you. My name is Robbie.",
     trigger: "Ask Name"
   },
   {
     id: "Ask Name",
     message: "What is your name?",
     trigger: "Waiting user input for name"
   },
   {
     id: "Waiting user input for name",
     user: true,
     trigger: "Display Name"
   },
   {
     id: "Display Name",
     message: "Hi {previousValue}!",
     trigger: "Asking options"
   },

   {
     id: "Asking options",
     message: "How can I help you today?",
     trigger: "Displaying options"
   },
   {
     id: "Displaying options",
     options: [
      {
        value: "contact support",
        label: "Contact Support",
        trigger: "Asking support"
      },
      { 
        value: "Services",
        label: "Services",
        trigger: "Asking Services"
      } 
          ]
   },
   {
     id: "Asking support",
     message:"Let me check if there is a live agent.",
     trigger: "Displaying support"
   },
   {
     id: "Displaying support",
     component: (
        <div class="link-container"> <a class="underlined-link" href="https://tawk.to/chat/587f2b9abcf30e71ac112360/default">click here to open live chat.</a> </div>
      ),
      trigger: "Asking again"
   },
   {
     id: "Asking Services",
     message: "Any particular service?",
     trigger: "Displaying services"
   },
   {
     id: "Displaying services",
     options: [
      {
        value: "Automating processes",
        label: "Automating processes",
        trigger: "Asking Automating"
      },
      { 
        value: "Optimising websites",
        label: "Optimising websites",
        trigger: "Asking optimising"
      },
      { 
        value: "Software development",
        label: "Software development",
        trigger: "Asking development"
      } 
          ]
   },
   {
     id: "Asking Automating",
     component: (
        <div class="link-container"> <a class="underlined-link" href="http://www.phaeria.com/digital-transformation-guide/automate-the-most-boring-tasks-first/">click here to find out more about automating tasks.</a> </div>
      ),
      trigger: "Asking again"
   },
   {
     id: "Asking optimising",
     component: (
        <div class="link-container"> <a class="underlined-link" href="http://www.phaeria.com/digital-transformation-guide/website-audit-and-optimisation/">click here to find out more about website optimisation.</a> </div>
      ),
      trigger: "Asking again"
   },
   {
     id: "Asking development",
     component: (
        <div class="link-container"> <a class="underlined-link" href="https://www.phaeria.com/services/software-development/">click here to find out more about software development.</a> </div>
      ),
      trigger: "Asking again"
   },

   {
     id: "Asking again",
     message: "Would you like to check other topics?",
     trigger: "Repeat options"
   },
   {
     id: "Repeat options",
     options: [
      {
        value: "ontact support",
        label: "Contact Support",
        trigger: "Asking support"
      },
      { 
        value: "Services",
        label: "Services",
        trigger: "Asking Services"
      },
      { 
        value: "nope",
        label: "No",
        trigger: "Asking No"
      } 
          ]
   },
    {
     id: "Asking No",
     message:"Have a lovely day!",
     end: true
   }
   
];
   
   return <ChatBot steps={steps} {...config} handleEnd={handleEnd}/>;
  }
  export default CustomChatbot;